// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"23a0a6cd","703":"3e6dfeec"}[chunkId] + ".chunk.js";
};